import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../../components/ui/tabs';
import EmailTemplates from './EmailTemplates';
import SmsTemplates from './SmsTemplates';
import HistoryTemplates from './HistoryTemplates';
import EnrollmentPdfTemplates from './EnrollmentPdfTemplates';

type TemplateTab = 'email' | 'sms' | 'history' | 'pdf';

const normalizeTab = (value: string | null): TemplateTab => {
  if (value === 'email' || value === 'sms' || value === 'history' || value === 'pdf') return value;
  return 'email';
};

const TemplatesHub = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeTab = normalizeTab(searchParams.get('tab'));

  return (
    <div className="mx-auto max-w-7xl space-y-6">
      <div>
        <h1 className="text-2xl font-semibold leading-7">Vorlagen</h1>
        <p className="text-muted-foreground">Zentrale Verwaltung aller Template-Kategorien.</p>
      </div>

      <Tabs
        value={activeTab}
        onValueChange={(value) => {
          const tab = normalizeTab(value);
          setSearchParams({ tab });
        }}
      >
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="email">E-Mail</TabsTrigger>
          <TabsTrigger value="sms">SMS</TabsTrigger>
          <TabsTrigger value="history">Historie</TabsTrigger>
          <TabsTrigger value="pdf">PDF</TabsTrigger>
        </TabsList>

        <TabsContent value="email">
          <EmailTemplates />
        </TabsContent>
        <TabsContent value="sms">
          <SmsTemplates />
        </TabsContent>
        <TabsContent value="history">
          <HistoryTemplates />
        </TabsContent>
        <TabsContent value="pdf">
          <EnrollmentPdfTemplates />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default TemplatesHub;
